import {change, Field} from "redux-form";
import React from "react";
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete';
import SVG from 'react-inlinesvg';
import activeCheckbox from "../images/Active@1x.svg";
import inactiveCheckbox from "../images/InActive@1x.svg";
import vinImageJeep from "../images/vin_jeep.jpg";
import vinImageAlfa from "../images/vin_alfa.jpg";
import vinImageFiat from "../images/vin_fiat.jpg";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';
import VideoRecorder from "react-video-recorder";
import moment from "moment";
import mimetype from "mimetype-extension";

const renderField = ({input, id, type, maxLength , className, helperText, meta: {touched, error, warning , invalid , asyncValidating}, placeholder}) => (


    <div className={`${className || ''} ${touched && error ? 'invalid-true' : ''}`}>
        <input {...input} id={id} placeholder={placeholder} type={type} className="form-control" maxLength={maxLength}/>
        {helperText && <small className="form-text text-muted">
            {helperText}
        </small>}
        {touched && ((error && <span className="text-danger error"> {error}</span>) || (warning &&
            <span>{warning}</span>))}
    </div>
);

const renderTextArea = ({input, id, type, maxLength , className, helperText, meta: {touched, error, warning , invalid , asyncValidating}, placeholder}) => {

    return (
        <div className={`${className || ''} ${touched && error ? 'invalid-true' : ''}`}>
            <TextArea {...input} id={id} type={type} className="form-control" maxLength={maxLength}/>
            {helperText && <small className="form-text text-muted">
                {helperText}
            </small>}
            {touched && ((error && <span className="text-danger error"> {error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    )
}

export function MultipleInputFields(props) {
    const {type, name, labelText, placeholder, onChange, targetField} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text",
        targetField: "tbc"
    }, props);
    return (
        <div className={`form-group multi-fields `}>
            <label className={`${props.required ? 'field-required' : ''}`} htmlFor={targetField}>{labelText}</label>
            {props.children}
        </div>)
}

export function DealerLookupField(props) {

    const renderDealerLookup = ({input, id, type, meta: {touched, error, warning, dispatch, form}, placeholder}) => {
        const searchOptions = {
            types: ['(regions)'],
            radius: 4000,
            location: new google.maps.LatLng(-34, 151) // sydney based search
        };

        return (
            <PlacesAutocomplete value={input.value}
                                onChange={input.onChange}
                                searchOptions={searchOptions}
                                onSelect={(address) => {
                                    geocodeByAddress(address)
                                        .then(results => {
                                            return results;
                                        })
                                        .then(results => {
                                            return results[0]
                                        })
                                        .then((res) => {
                                            dispatch(change(form, input.name, res.formatted_address));
                                            const matches = res.formatted_address.match(new RegExp(/[0-9]{4}/));
                                            if (matches.length > 0) {
                                                dispatch(change(form, 'address', matches[0]));
                                            }
                                        })
                                }}>
                {({getInputProps, getSuggestionItemProps, loading, suggestions}) => {
                    return (
                        <div className="autocomplete-root">
                            <div className="input-group">

                                <input {...getInputProps({
                                    className: 'form-control',
                                    id: id,
                                    name: props.name,
                                    placeholder: placeholder,

                                })} />


                            </div>
                            {input.value.trim().length > 0 && suggestions.length === 0 &&
                            <span className={"float-input-icon"}>
                                    {<i onClick={() => {
                                        dispatch(change(form, input.name, ''));
                                        dispatch(change(form, 'address', ''));
                                    }} className="fas fa-times"/>}

                            </span>}

                            {suggestions.length > 0 && <div className="autocomplete-dropdown-container">
                                {suggestions.filter((s) => {
                                    return /.*Australia.*/.test(s.description)
                                }).map(suggestion => (

                                    <div {...getSuggestionItemProps(suggestion)}>
                                        <span>{suggestion.description}</span>
                                    </div>
                                ))}
                            </div>}
                        </div>
                    );
                }}
            </PlacesAutocomplete>
        )
    };


    return (
        <div className="form-group">
            <label htmlFor={props.name}>{props.labelText}</label>
            <Field component={renderDealerLookup} onChange={() => {
            }} name={props.name} {...props}/>
        </div>
    )
}

export function TextArea(props) {
    const {type, name, labelText, placeholder, onChange, onBlur} = Object.assign({}, {

        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);

    const renderTextArea = (p) => {
        const {input, maxLength , id, type, className, helperText, subLabelText, meta: {touched, error, warning}, placeholder} = p;

        return <div>
            {subLabelText && <div className="form-sub-label">
                {subLabelText}
            </div>}
            <textarea className="form-control" cols={10} rows={5} name={id} id={id} {...input} maxLength={maxLength} />
            {helperText && <small className="form-text text-muted">
                {helperText}
            </small>}
            {touched && ((error && <span className="text-danger error"> {error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    };

    return (
        <div className="form-group">
            <label htmlFor={name}>{labelText}</label>
            <Field id={name} name={name} component={renderTextArea}
                    {...props}
                   />
        </div>
    )
}

export function ContactUsOwnerOptions(props) {
    const {type, name, labelText, placeholder, onChange, onBlur} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "No Defined", name: "tbc", type: "text"
    }, props);

    const renderOption = ({input, id, name , type, className, helperText, meta: {touched, error, warning}, placeholder}) => {
        return <input className="form-check-input" type="radio" name={name} id={id} {...input}/>
    };
    return (
        <div className={`form-group`}>
            <label>{labelText}</label>
            <div>
                <div className="form-check form-check-inline">
                    <Field name={"owner"} component={"input"} type={"radio"} value={"no"} className={"form-check-input"} id={"ownerOption1"} />
                    <label className="form-check-label" htmlFor="ownerOption2">No</label>
                </div>
                <div className="form-check form-check-inline">
                    <Field name={"owner"} component={"input"} type={"radio"} value={"yes"} className={"form-check-input"} id={"ownerOption1"} />
                    <label className="form-check-label" htmlFor="ownerOption1">Yes</label>
                </div>
            </div>
        </div>
    )
}

export function InputField(props) {
    const {type, name, labelText, placeholder, onChange, onBlur} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);
    return (
        <div className="form-group">
            <label className={`${props.required ? 'field-required' : ''}`} htmlFor={name}>{labelText}</label>
            <Field id={name} name={name} component={renderField} placeholder={placeholder} onBlur={onBlur}
                   onChange={onChange} {...props}
                   type={type}/>
        </div>
    )
}


export function VideoDisplay(props){
    const component = (p) => {
        if(p.input.value){
            return <video src={p.input.value} autoPlay={false} playsInline controls style={{width:'100%'}}/>
        }
        else{
           return <></>
        }
    }
    return <div className={'form-group'}><Field component={component} {...props}  name='videoblob' /></div>
}

export function VideoInput(props){
    console.log({props});
    const {type, name, labelText, placeholder, onChange} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);

    const component = (p) => {
        const {input, id, type, maxLength , className, helperText, subLabelText, meta: {touched, error, warning , invalid , asyncValidating , dispatch, form}, placeholder} = p;
        return ( <div className="form-group">
            <label htmlFor={'file'}>{props.labelText}</label>
            {subLabelText && <div className="form-sub-label">
                {subLabelText}
            </div>}
            <input className={'form-control pb-5'} type={'file'} name={'video'} id={'video'} onChange={(e) => {
                if(e.target.files && e.target.files.length > 0 ){
                    let video = e.target.files[0];
                    input.onChange(video);
                    dispatch(change(form, 'videosize' , video.size));
                    dispatch(change(form , 'videoblob' , URL.createObjectURL(video)))
                    dispatch(change(form , 'videoUrl' , `${moment().unix()}-${Math.round(Math.random() * 1000).toFixed(0)}-video.${(mimetype.ext(video.type))}`))
                }
            }}/>
            <div className={`${className || ''} ${touched && error ? 'invalid-true' : ''}`}>
                {helperText && <small className="form-text text-muted">
                    {helperText}
                </small>}
                {((error && <span className="text-danger error"> {error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
        </div>)
    }

    return <Field  {...props} component={component} />



}

export function NoLabelField(props) {
    const {type, name, labelText, placeholder, onChange} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);
    return (
        <Field {...props} id={name} name={name} component={renderField} placeholder={placeholder} onChange={onChange}
               type={type}/>
    )
}

export function SubmitButton(props) {
    return <button type="submit" disabled={props.disabled} className="btn btn-primary btn-block">Submit</button>
}

export function CheckBox(props) {
    const {type, name, labelText, placeholder, onChange} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);

    const renderCheckBox = ({input, id, type, className, meta: {touched, error, warning, dispatch , form }, placeholder}) => (
        <span className={'optIn'}>

            <label className="form-check-label" htmlFor={name}>
                {input.value === true && <span onClick={() => { dispatch(change(form  , input.name , !input.value ))}}><SVG src={activeCheckbox} className={'activeCheck'} /></span>}
                {input.value !== true && <span onClick={() => {dispatch(change(form  , input.name , !input.value ))}}><SVG src={inactiveCheckbox }  /></span>}
                {labelText}</label>
            {props.children}
            <div>
                {touched && ((error && <span className="text-danger error"> {error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
        </span>
    );


    return (
        <div className="form-group">
            <div className="form-check pl-0">
                <Field component={renderCheckBox} type={"checkbox"} className={"form-check-input"} {...props}/>

            </div>
        </div>
    )
}

export function ComplexDropDownMenu(props){
    const items = props.items || [];

    const renderField = ({input, id, type, className, helperText, meta: {touched, error, warning}, placeholder}) => {
        return <select {...input} className="form-control" id={id} value={input.value}  >
            {(input.value === undefined || input.value.length === 0) && <option key="Select" value="" disabled="disabled" hidden={true}>Select</option> }
            {items.map((item, key) => <option key={key} value={item.postcode} >{item.name} {item.suburb}</option>)}
        </select>
    };

    return (

        <div className="form-group">
            <label className={`${props.required ? 'field-required' : ''}`} htmlFor={props.name}>{props.labelText}</label>
            <Field component={renderField} name={props.name} id={props.id}/>
        </div>
    )
}

export function DropDownMenu(props) {
    const items = props.items || [];

    const renderField = ({input, id, type, className, helperText, meta: {touched, error, warning}, placeholder}) => {
        return <select {...input} className="form-control" id={id} value={input.value}  >
            {(input.value === undefined || input.value.length === 0) && <option key="Select" value="" disabled="disabled" hidden={true}>Select</option> }
            {items.map((item, key) => <option key={key} value={item} >{item}</option>)}
        </select>
    };

    return (

        <div className="form-group">
            <label className={`${props.required ? 'field-required' : ''}`} htmlFor={props.name}>{props.labelText}</label>
            <Field component={renderField} name={props.name} id={props.id}/>
        </div>
    )
}

class DayPicker extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            input: { value, onChange , name },
            meta : { form , dispatch },
        } = this.props
        const cssClassNames = {
            container : 'form-control'
        }
        const FORMAT = 'dd/MM/yyyy';
        return (
            <div >
                <DayPickerInput
                    className={ cssClassNames }
                    value={value}
                    formatDate={formatDate}
                    format={FORMAT}
                    parseDate={parseDate}
                    placeholder={"dd/mm/yyyy"}
                    onDayChange={(selectedDay, modifiers, dayPickerInput) => { dispatch(change(form, name , selectedDay)); }}
                    dayPickerProps={{
                        selectedDays: value,
                    }}
                />
            </div>
        );
    }
}

export function DateDropDownMenu(props) {

    return (

        <div className="form-group">
            <label className={`${props.required ? 'field-required' : ''}`} htmlFor={props.name}>{props.labelText}</label>
            <Field className={'form-control'} component={DayPicker} name={props.name} id={props.id} placeholder={props.placeholder}/>
        </div>
    )
}

export function VINModal(props) {
    const [showModal, setShowModal] = React.useState(false)

    function handleClose(e) {
        e.preventDefault();
        setShowModal(false)
      }

    let vin_text = "The VIN can be found on the VIN plate located on the driver's side of the dashboard just below the windshield (1). The VIN can also be found on the driver-side doorframe label (2), as well as on documents related to the vehicle's registration, title and insurance.";
    let vin_image = vinImageJeep;
    if(props.brand == "Alfa Romeo"){
        vin_text = "The VIN can be found on the VIN plate located on the driver's side of the dashboard just below the windshield (1). The VIN can also be found on the driver-side doorframe label (2), as well as on documents related to the vehicle's registration, title and insurance.";
        vin_image = vinImageAlfa;
    }else if(props.brand == "Fiat"){
        vin_text = "For Passenger vehicles, the VIN can be found on the VIN plate located on the driver's side of the dashboard just below the windshield. The VIN can also be found on the driver-side doorframe label, as well as in the documents related to the vehicle's registration, title and insurance. For Fiat Professional vehicles, the VIN can be found on the passenger side of the windshield in the lower corner, embedded in dash.";
        vin_image = vinImageFiat;
    }
    return (
        <div>
            <p onClick={() => setShowModal(true)} style={{marginBottom: '20px'}}><span className="info btn-primary">i</span> <span style={{cursor: 'pointer', textDecoration: 'underline'}}>Help me find my VIN</span></p>
            <div className={showModal ? "modal" : "modal modal-hidden"} onClick={handleClose} >
                <div className="modal-content">
                    <div className="modal-body">
                        <div>
                            <button type="button" className="close">
                                <span>&times;</span>
                            </button>
                            <h4>WHAT IS A VIN?</h4>
                            <p>A VIN is a Vehicle Identification Number. It is a 17-character alphanumeric identifier or a manufacturer’s serial number. Each character in the VIN number has a significant meaning. Together, they create a number that provides information about the vehicle and its unique history.</p>
                        </div>
                        <div>
                            <h4>WHERE IS THE VIN LOCATED?</h4>
                            <p>{vin_text}</p>
                        </div>
                        <img src={vin_image} style={{width: '100%'}}></img>
                    </div>
                </div>
            </div>
        </div>
    )
}


export function CompCheckBox(props) {
    const {type, name, labelText, placeholder, onChange} = Object.assign({}, {
        onChange: function () {
        },
        placeholder: "",
        labelText: "", name: "tbc", type: "text"
    }, props);

    const renderCheckBox = ({input, id, type, className, meta: {touched, error, warning, dispatch , form }, placeholder}) => (
        <span className={'optIn'}>

            <label className="form-check-label" htmlFor={name}>
                {input.value === true && <span onClick={() => { dispatch(change(form  , input.name , !input.value ))}}><SVG src={activeCheckbox} className={'activeCheck'} /></span>}
                {input.value !== true && <span onClick={() => {dispatch(change(form  , input.name , !input.value ))}}><SVG src={inactiveCheckbox }  /></span>}
                I am happy to receive offers, discounts and updates from Jeep in accordance with Jeep Australia's  <a href={'https://www.jeep.com.au/owners/privacy.html'} target={"_blank"}>Privacy Policy</a>
                </label>
            {props.children}
            <div>
                {touched && ((error && <span className="text-danger error"> {error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
        </span>
    );


    return (
        <div className="form-group">
            <div className="form-check pl-0">
                <Field component={renderCheckBox} type={"checkbox"} className={"form-check-input"} {...props}/>

            </div>
        </div>
    )
}

function parseDate(str, format, locale) {
    const parsed = dateFnsParse(str, format, new Date(), { locale });
    if (DateUtils.isDate(parsed)) {
      return parsed;
    }
    return undefined;
  }
  
  function formatDate(date, format, locale) {
    return dateFnsFormat(date, format, { locale });
  }
  